import { render } from "./productImageWrap.vue?vue&type=template&id=d879e0f4&scoped=true"
import script from "./productImageWrap.vue?vue&type=script&lang=js"
export * from "./productImageWrap.vue?vue&type=script&lang=js"

import "./productImageWrap.vue?vue&type=style&index=0&id=d879e0f4&scoped=true&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d879e0f4"]])

export default __exports__